import React, {useState} from 'react'; // Import useState
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import ConservationSearch from './ConservationSearch';
import CatalogSearch from './CatalogSearch';
import AcquisitionSearch from './AcquisitionSearch';
import {styleBg} from '../../../common/Models/Validations';
import LoanSearch from "./LoanSearch";
import TransferSearch from "./TransferSearch";
import DeaccessionSearch from "./DeaccessionSearch";
import PageWrapper from '../../../common/PageWrapper/PageWrapper';


function CustomTabPanel(props) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{pt: 3}}>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function ReportsMain(props) {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <PageWrapper>
      <Box className={'space-between'} sx={{mt: 6}}>
        <Typography className={'museum-font'} sx={{mb: 1}}>Reports</Typography>
        <Box className={'header-divider'}/>
      </Box>
      <Box sx={{borderBottom: 1, borderColor: 'divider', width: '100%'}}>
        <Tabs 
          value={value} 
          onChange={handleChange} 
          aria-label="basic tabs example"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab label="CATALOG REPORT" {...a11yProps(0)} sx={{minWidth: 200, ...styleBg(0, value)}}/>
          <Tab label="ACQUISITION REPORT" {...a11yProps(1)} sx={{minWidth: 200, ...styleBg(1, value)}}/>
          <Tab label="CONSERVATION REPORT" {...a11yProps(2)} sx={{minWidth: 200, ...styleBg(2, value)}}/>
          <Tab label="LOAN REPORT" {...a11yProps(3)} sx={{minWidth: 200, ...styleBg(3, value)}}/>
          <Tab label="TRANSFER REPORT" {...a11yProps(4)} sx={{minWidth: 200, ...styleBg(4, value)}}/>
          <Tab label="DEACCESSION REPORT" {...a11yProps(5)} sx={{minWidth: 200, ...styleBg(5, value)}}/>
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <CatalogSearch tabIndex={0}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <AcquisitionSearch tabIndex={1}/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <ConservationSearch tabIndex={2}/>
      </CustomTabPanel>
      <CustomTabPanel index={3} value={value}>
        <LoanSearch tabIndex={3}/>
      </CustomTabPanel>
      <CustomTabPanel index={4} value={value}>
        <TransferSearch tabIndex={4}/>
      </CustomTabPanel>
      <CustomTabPanel index={5} value={value}>
        <DeaccessionSearch tabIndex={5}/>
      </CustomTabPanel>
    </PageWrapper>
  );
}
